import React, {useState} from "react";
import {useReadErpAccountList} from "../../../../pages/customer/correspondent/detail/hooks";
import {BasicSearchType} from "../../../../types/common/basic";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {SubmitHandler, useForm} from "react-hook-form";
import {SearchErpAccountResType} from "../../../../pages/customer/correspondent/detail/interface";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";

export const SearchErpInner = ({
                                   confirmCallback,
                                   cancelCallback,
                                   modalDepth
                               }: ModalInnerConfirmType<SearchErpAccountResType>) => {
    const defaultSearchValue = {
        limit: 10,
        pageNo: 1,
        keywordType: "0",
        keyword: "",
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<BasicSearchType>(defaultSearchValue);

    const [selectItem, setSelectItem] = useState<SearchErpAccountResType | null>(
        null
    );

    const {data} = useReadErpAccountList({SearchData: searchOption});

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<BasicSearchType> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth)
    }

    const onConfirm = () => {
        if (selectItem?.new_erp_accountid) {
            confirmCallback(selectItem);
            onClose()
        } else {
            handleModal({
                isOpen: true,
                contents: "ERP 거래처를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1
            })
        }
    }

    const onCancel = () => {
        onClose()
        cancelCallback && cancelCallback()
    }

    const formatBusinessNumber = (value: string) => {
        // 숫자만 추출
        const digits = value.replace(/\D/g, '');

        // 10자리 아니면 그대로 반환
        if (digits.length !== 10) return value;

        // 하이픈 추가 포맷팅
        return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
    }

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={"0"}>전체</option>
                    <option value={"1"}>이름</option>
                    <option value={"2"}>대표자</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th style={{width: "7.1%"}}></th>
                    <th>거래처명</th>
                    <th>거래처코드</th>
                    <th>대표자</th>
                    <th>사업자등록번호</th>
                </tr>
                </thead>
                <tbody>
                {(data?.erpAccountList ?? [])?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data?.erpAccountList ?? [])?.map((item: SearchErpAccountResType) => {
                        return (
                            <tr className={`clickable ${item.new_erp_accountid === selectItem?.new_erp_accountid ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onClick={() => {
                                                setSelectItem(item);
                                            }}
                                            checked={
                                                selectItem?.new_erp_accountid ===
                                                item?.new_erp_accountid
                                            }
                                        />
                                    </div>
                                </td>
                                <td className="text-center">
                                    {item?.new_txt_nm_partner ?? "-"}
                                </td>
                                <td className="text-center">{item?.newTxtCdPartner ?? "-"}</td>
                                <td className="text-center">{item?.newTxtNmCeo ?? "-"}</td>
                                <td className="text-center">{formatBusinessNumber(item?.newTxtNoCompany ?? "-")}</td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>

            <PaginationSub totalCount={data?.totalCount ?? 0}
                           currentPage={searchOption.pageNo}
                           onChangeCallback={(i) => setSearchOption({...searchOption, pageNo: i})}/>

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={() => {
                        onConfirm()
                        // if (setValue && selectItem?.new_erp_accountid) {
                        //     console.log("아이템", selectItem);
                        //     // ERP 코드
                        //     setValue(
                        //         "newTxtCdPartner",
                        //         selectItem?.newTxtCdPartner as string,
                        //         {
                        //             shouldDirty: true,
                        //         }
                        //     );
                        //     // erp 거래처 id
                        //     setValue("newLAccountErpValue", selectItem?.new_erp_accountid, {
                        //         shouldDirty: true,
                        //     });
                        //     // erp 거래처 이름
                        //     setValue(
                        //         "newTxtNmPartner",
                        //         selectItem?.new_txt_nm_partner as string,
                        //         {
                        //             shouldDirty: true,
                        //         }
                        //     );
                        //     // 수금방법
                        //     setValue("newPFgBill", selectItem?.newPFgBill ?? null, {
                        //         shouldDirty: true,
                        //     });
                        //     // 예산한도
                        //     setValue("newDTotCredit", selectItem?.newDTotCredit ?? null, {
                        //         shouldDirty: true,
                        //     });
                        //     // 대표자
                        //     setValue("newTxtNmCeo", selectItem?.newTxtNmCeo ?? "", {
                        //         shouldDirty: true,
                        //     });
                        //     // 수금예정월
                        //     setValue("newPTpRcpDd", selectItem?.newPTpRcpDd ?? null, {
                        //         shouldDirty: true,
                        //     });
                        //     // 대표전화
                        //     setValue("newTxtNoTel", selectItem?.newTxtNoTel ?? null, {
                        //         shouldDirty: true,
                        //     });
                        //     // 수금예정일
                        //     setValue("newIDtRcpDd", selectItem?.newIDtRcpDd ?? null, {
                        //         shouldDirty: true,
                        //     });
                        //     // 주소1
                        //     setValue("newTxtDcAds1D", selectItem?.newTxtDcAds1D ?? "", {
                        //         shouldDirty: true,
                        //     });
                        //     // 주소2
                        //     setValue("newTxtDcAds1H", selectItem?.newTxtDcAds1H ?? "", {
                        //         shouldDirty: true,
                        //     });
                        //     if (resetModal) {
                        //         resetModal();
                        //     }
                        // } else {
                        //     console.log("선택 없음", setValue, selectItem);
                        // }
                    }}
                >
                    선택
                </button>
            </div>
        </>
    );
};
